import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import { toast } from 'react-toastify';
import { getApi } from 'views/services/api';
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FoodInvoiceDialog from './FoodInvoiceDialog';
import { margin } from '@mui/system';

// ----------------------------------------------------------------------

const SeparateFoodView = () => {
  const [openMakeOrder, setOpenMakeOrder] = useState(false);
  const [selectedFoodItems, setSelectedFoodItems] = useState([]);
  const navigate = useNavigate();
  const [itemsData, setItemsData] = useState([]);
  const [quantityMap, setQuantityMap] = useState({});
  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  const baseUrl = process.env.REACT_APP_BASE_URL;

  // Fetch all the restaurant items data from the db
  const fetchItemsData = async () => {
    try {
      // const response = await getApi(`api/restaurant/viewallitems/${hotel._id}`);
      const response = await getApi(`api/restaurant/viewallitems/${hotel?.hotelId}`);
      console.log('res =>', response);
      // const items = response?.data?.restaurantData || [];

      const formattedData = response?.data?.restaurantData.map((item) => ({
        ...item,
        itemImage: item.itemImage.split('/').pop()
      }));
      setItemsData(formattedData);

      // Initialize quantity map with initial quantity as 0 for each item
      const initialQuantityMap = {};
      formattedData.forEach((item) => {
        initialQuantityMap[item._id] = 0; // Initialize quantity as 0 for each item
      });
      setQuantityMap(initialQuantityMap);
      setItemsData(items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchItemsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openMakeOrder]);

  // open the dialog box
  const handleMakeOrder = () => {
    setOpenMakeOrder(true);
  };
  const handleCloseMakeOrder = () => {
    setOpenMakeOrder(false);
  };

  const handleAddButtonClick = async () => {
    const selectedItems = itemsData.filter((item) => quantityMap[item._id] > 0);
    const foodItems = selectedItems.map((item) => {
      return {
        id: item._id,
        name: item.itemName,
        price: item.amount,
        quantity: quantityMap[item._id]
      };
    });

    try {
      if (foodItems.length === 0) {
        toast.error('Please select at least one item');
      } else {
        setSelectedFoodItems(foodItems);
        handleMakeOrder();
      }
    } catch (error) {
      console.log(error);
      toast.error('Cannot add food item(s)');
    }
  };

  // Function to handle incrementing quantity for a specific item
  const handleIncrementQuantity = (itemId) => {
    setQuantityMap((prevQuantityMap) => ({
      ...prevQuantityMap,
      [itemId]: (prevQuantityMap[itemId] || 0) + 1
    }));
  };

  // Function to handle decrementing quantity for a specific item
  const handleDecrementQuantity = (itemId) => {
    setQuantityMap((prevQuantityMap) => ({
      ...prevQuantityMap,
      [itemId]: Math.max((prevQuantityMap[itemId] || 0) - 1, 0)
    }));
  };

  const columns = [
    {
      field: 'itemImage',
      headerName: 'Item Image',
      flex: 1,
      // renderCell: (params) => {
      //   return (
      //     <div>
      //       <img src={params?.value} alt="item" style={{ width: '20%', height: '10%', borderRadius: '10px' }} />
      //     </div>
      //   );
      // }
      renderCell: (params) => (
        <div>
          <img
            src={`${baseUrl}api/uploads/restaurant/Item/${params.value}`}
            alt="item"
            style={{ width: '40px', height: '40px', borderRadius: '10px' }}
          />
        </div>
      )
    },
    {
      field: 'itemName',
      headerName: 'Item Name',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        const itemPrice = params.value;
        const itemQuantity = quantityMap[params.row._id] || 0;
        const totalPrice = itemPrice * itemQuantity;
        return <Box>{hotel?.currencyCode} {totalPrice}</Box>;
      }
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton onClick={() => handleIncrementQuantity(params.row._id)}>
            <AddIcon />
          </IconButton>
          {quantityMap[params.row._id] || 0}
          <IconButton onClick={() => handleDecrementQuantity(params.row._id)}>
            <RemoveIcon />
          </IconButton>
        </Stack>
      )
    }
  ];

  return (
    <>
      <FoodInvoiceDialog open={openMakeOrder} handleClose={handleCloseMakeOrder} data={selectedFoodItems} />
      <Container>
        <Typography variant="h4">Food Items</Typography>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'end'} gap={3}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleAddButtonClick}>
            Place Order
          </Button>
        </Stack>
        {/* <Stack direction="row" alignItems="center" justifyContent={'flex-end'} sx={{ marginTop: '10px' }} spacing={2}>
          
        </Stack> */}
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Items ( {itemsData?.length || 0} )
              </Typography>
              {itemsData && (
                <DataGrid
                  rows={itemsData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                  rowHeight={60}
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default SeparateFoodView;
